// extracted by mini-css-extract-plugin
module.exports = {"container":"Nv-z","creativeContainer":"Ov-z","copy":"Pv-z","cta":"Qv-z","disabled":"Rv-z","flipped":"Sv-z","card":"Tv-z"};